import cx from 'classnames'
import { Field } from '../AddReviewers/Field'
import AddReviewersStyles from '../AddReviewers/AddReviewers.module.scss'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { forwardRef, useCallback, useState } from 'react'
import { ProseInput } from 'common/ProseInput/ProseInput'
import { ProseState } from 'common/ProseInput/ProseState'
import { ProseStateProvider } from 'common/ProseInput/ProseStateContext'
import { useSelector } from '@xstate/react'
import { useReviewsWizard } from '../ReviewsWizardProvider'
import { EventId } from '../machineTypes'
import { Toolbar } from 'common/ProseInput/components/Toolbar'
import { ProseInputHandle } from 'common/ProseInput/Types'

export const MessageField = forwardRef<ProseInputHandle, { isDisabled?: boolean }>(({ isDisabled = false }, ref) => {
  const { service, isLoading } = useReviewsWizard()
  const richText = useFlipperFlag('richtext_comments')
  const [proseState] = useState(() => new ProseState())
  const message = useSelector(service, (state) => state.context.message)
  const htmlMessage = useSelector(service, (state) => state.context.htmlMessage)
  const reviewers = useSelector(service, (state) => state.context.reviewers)
  const approvers = useSelector(service, (state) => state.context.approvers)

  const handleMessageChange = useCallback(
    (newMessagePlainText: string, newMessageHtml?: string) => {
      service.send(EventId.SET_MESSAGE, { message: newMessagePlainText, htmlMessage: newMessageHtml })
    },
    [service],
  )

  return (
    <>
      <label htmlFor="message" className={AddReviewersStyles.fieldLabel}>
        Message
      </label>
      <Field className={cx({ [AddReviewersStyles.messageField]: richText })}>
        {richText ? (
          <ProseStateProvider state={proseState}>
            <Toolbar.Root className={AddReviewersStyles.toolbar}>
              <Toolbar.Bold />
              <Toolbar.Italic />
              <Toolbar.Underline />
              <Toolbar.InlineCode />
              <Toolbar.OrderedList />
              <Toolbar.BulletList />
              <Toolbar.Mention />
              <Toolbar.Emoji />
            </Toolbar.Root>
            <ProseInput
              placeholder="Type your message here..."
              className={cx(AddReviewersStyles.fieldInput, AddReviewersStyles.message)}
              initialHtmlString={htmlMessage || ''}
              onChange={(html, plainText) => handleMessageChange(plainText, html)}
              ref={ref}
            />
          </ProseStateProvider>
        ) : (
          <textarea
            id="message"
            autoFocus={approvers.length > 0 || reviewers.length > 0}
            className={cx(AddReviewersStyles.fieldInput, AddReviewersStyles.message)}
            placeholder="Type your message here..."
            value={message}
            onChange={(e) => handleMessageChange(e.target.value)}
            rows={5}
            disabled={isLoading || isDisabled}
          />
        )}
      </Field>
    </>
  )
})
